import { render } from "./CustomerForm.vue?vue&type=template&id=50f5eff6&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"

import "./CustomerForm.vue?vue&type=style&index=0&id=50f5eff6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f5eff6"]])

export default __exports__